import { render, staticRenderFns } from "./coreWebVitalsView.vue?vue&type=template&id=0569dda5"
import script from "./coreWebVitalsView.vue?vue&type=script&lang=ts"
export * from "./coreWebVitalsView.vue?vue&type=script&lang=ts"
import style0 from "./coreWebVitalsView.vue?vue&type=style&index=0&id=0569dda5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports